import React, { useState } from 'react';
import Navigation from '../components/landing/Navigation';
import HeroSection from '../components/landing/HeroSection';
import WhyChooseUsSection from '../components/landing/WhyChooseUsSection';
import ServicesSection from '../components/landing/ServicesSection';
import WhoWeHelpSection from '../components/landing/WhoWeHelpSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import PricingSection from '../components/landing/PricingSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import FAQSection from '../components/landing/FAQSection';
import EnquiryForm from '../components/landing/EnquiryForm';
import FinalCTASection from '../components/landing/FinalCTASection';
import PortalAccessSection from '../components/landing/PortalAccessSection';
import Footer from '../components/landing/Footer';
import FloatingActionButtons from '../components/shared/FloatingActionButtons';
import Seo from '../components/shared/Seo';
import { HOME_PAGE_SCHEMA } from '../lib/seo';
import '../App.css';

const LandingPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('ielts');

  const scrollToBooking = () => {
    document.getElementById('enquiry-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Winhouse Tutors | VCE, IELTS & Selective Entry Tutors"
        description="Find expert tutors for VCE, IELTS, and Selective Entry. Online and in-person tutoring tailored to your success."
        path="/"
        jsonLd={HOME_PAGE_SCHEMA}
      />
      <Navigation mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      
      <HeroSection scrollToBooking={scrollToBooking} />
      
      <WhyChooseUsSection />
      
      <ServicesSection scrollToBooking={scrollToBooking} />
      
      <WhoWeHelpSection />
      
      <HowItWorksSection scrollToBooking={scrollToBooking} />
      
      <PricingSection 
        selectedService={selectedService} 
        setSelectedService={setSelectedService} 
        scrollToBooking={scrollToBooking} 
      />
      
      <TestimonialsSection />
      
      <FAQSection />
      
      <EnquiryForm />
      
      <FinalCTASection scrollToBooking={scrollToBooking} />

      <PortalAccessSection />

      <Footer />

      {/* Shared Floating Action Buttons (Book Free Trial + WhatsApp) */}
      <FloatingActionButtons />
    </div>
  );
};

export default LandingPage;
